import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageLoader } from '../components/LoadingSpinner';
import { toast } from 'sonner';

/**
 * AuthCallback - Processes Emergent OAuth #session_id= fragment.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const { loginWithGoogle } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processSession = async () => {
            try {
                const hash = window.location.hash;
                const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

                if (!sessionId) {
                    toast.error('Authentication failed: no session received');
                    navigate('/login', { replace: true });
                    return;
                }

                // Exchange session_id for JWT via backend
                const userData = await loginWithGoogle(sessionId);
                toast.success(`Welcome, ${userData.name}!`);
                navigate('/dashboard', { replace: true });
            } catch (error) {
                console.error('Google auth error:', error);
                const message = error.response?.data?.detail || 'Google authentication failed';
                toast.error(message);
                navigate('/login', { replace: true });
            }
        };

        processSession();
    }, []);

    return <PageLoader />;
}
